import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-baccab7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }

import Center from "@/components/Center.vue";
import ThankYou from "@/components/form/ThankYou.vue";
import { useAppStore } from "@/pinia/appStore";
import { onMounted } from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'ThankYouView',
  setup(__props) {

const router = useRouter();
const session = useAppStore();
onMounted(() => {
	if (!session.$state.formSentSuccesfully) {
		session.$state.formSentSuccesfully = false;
		router.push({ name: "home" });
	}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(session).$state.formSentSuccesfully)
      ? (_openBlock(), _createBlock(Center, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(ThankYou)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})